import React, { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const SettingsContext = React.createContext({ settings: null, refresh: () => {} });

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (_) { /* ignore */ }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, refresh, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => React.useContext(SettingsContext);
